module.exports = __webpack_public_path__ + "static/media/miniclip-8-ball-pool-avatar-8.3d8b5f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/miniclip-8-ball-pool-avatar-8.png
// module id = 207
// module chunks = 0